module.exports = __webpack_public_path__ + "img/bannerUVV.b45016ee.png";